import Request from 'gd-request';

export default class ApiRecent {

    constructor() {}

    tasks() {
        return new Request(this, 'GET', 'recent/tasks');
    }

    // projects() {
    //     return new Request(this, 'GET', 'recent/projects');
    // }
}